export default __webpack_public_path__ + "static/media/field.3e1f05fb.png";